import React from 'react'
import RoutesComponent from '../../routes/Routes'
import { useAppVersionCheck } from '../../hooks/useAppVersionCheck'

function App() {
	useAppVersionCheck()

	return (
		<div className="App">
			<RoutesComponent />
		</div>
	)
}

export default App
